import { createRouter, createWebHistory } from 'vue-router'

import HomePage from '@/components/frontoffice/HomePage.vue'
import LoginPage from '@/pages/LoginPage.vue'
import AppShell from '@/layouts/AppShell.vue'
import DashboardPage from '@/pages/app/DashboardPage.vue'
import ShipmentsPage from '@/pages/app/ShipmentsPage.vue'
import CommandesPage from '@/pages/app/CommandesPage.vue'
import CommandeDetailsPage from '@/pages/app/CommandeDetailsPage.vue'
import AdminGroupingRequestsPage from '@/pages/admin/AdminGroupingRequestsPage.vue'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: HomePage },
    { path: '/login', name: 'login', component: LoginPage },
    {
      path: '/app',
      component: AppShell,
      children: [
        { path: '', redirect: { name: 'app.dashboard' } },
        { path: 'dashboard', name: 'app.dashboard', component: DashboardPage },
        { path: 'shipments', name: 'app.shipments', component: ShipmentsPage },
        { path: 'commandes', name: 'app.commandes', component: CommandesPage },
        { path: 'commandes/:id', name: 'app.commandes.details', component: CommandeDetailsPage }
      ]
    },
    {
      path: '/admin',
      component: AppShell,
      children: [
        { path: '', redirect: { name: 'admin.grouping-requests' } },
        {
          path: 'regroupements',
          name: 'admin.grouping-requests',
          component: AdminGroupingRequestsPage,
          meta: { requiresAdmin: true }
        }
      ]
    },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash }
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  if (to.meta?.requiresAdmin) {
    const auth = useAuthStore()
    if (!auth.isAdmin) {
      return { name: 'app.dashboard' }
    }
  }
  return true
})

export default router
